import { render } from "./PostSingleTag.vue?vue&type=template&id=34b8b500&scoped=true"
import script from "./PostSingleTag.vue?vue&type=script&lang=js"
export * from "./PostSingleTag.vue?vue&type=script&lang=js"

import "./PostSingleTag.vue?vue&type=style&index=0&id=34b8b500&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b8b500"]])

export default __exports__